$(document).ready(function(){
    $('.slider-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.slider-nav',
					   
    });
    $('.slider-nav').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.slider-for',
        dots: false,
        focusOnSelect: true,
        arrows:true,
		    vertical:true,
        responsive: [
          {
            breakpoint: 1201,
            settings: {
              slidesToShow: 4
            }
          },
          {
            breakpoint:993,
            settings: {
              slidesToShow:5,
			        vertical:false,
            }
          },
          {
            breakpoint:577,
            settings: {
              slidesToShow:3,
			        vertical:false,
            }
          },
          {
            breakpoint:481,
            settings: {
              slidesToShow:2,
			        vertical:false,
            }
          }
          ]
      });

       // init_related_slick();
      // $("details").removeAttr("open");
      // $("details summary").attr("aria-expanded","false");
  
      $("#write_review").on("click",function(){
        $('html, body').animate({
          scrollTop: $(".review-tab").offset().top - 700
        }, 1500);
        $(".review-tab details").attr("open","open");
        $(".review-tab details summary").attr("aria-expanded","true");
      });
      $("#view_description").on("click",function(){
        $('html, body').animate({
          scrollTop: $(".description-tab").offset().top - 250
        }, 1500);
        $(".description-tab details").attr("open","open");
        $(".description-tab details summary").attr("aria-expanded","true");
      });
});

$( window ).on( "scroll", function() {
        $(".product-like-list .product-list").not('.slick-initialized').slick({
        // $('.product-like-list .product-list').slick({
                arrows: true,
                dots: false,
                slidesToShow: 4,
                slidesToScroll: 1,
                horizontal: true,
                infinite: true,
                autoplay: false,
                pauseOnHover: false,
                autoplaySpeed: 3000,
                responsive: [
                {
                  breakpoint: 1441,
                  settings: {
                    slidesToShow: 4
                  }
                },
                {
                  breakpoint: 1201,
                  settings: {
                    slidesToShow: 3
                  }
                },
                        {
                  breakpoint: 769,
                  settings: {
                    slidesToShow: 2
                  }
                }
                ]
          });
});
// $(window).on('load', function() {
//   //console.log("test");
//   init_related_slick();
// });